import useLearningPathNavigation from 'features/useLearningPathNavigation';
import {fetchActivitiesRequest} from 'APIs/letrusAPI/activities';
import {CTABanner} from '../CTABannersCarousel';

function useActivitiesToFinishBanner({
  priority,
}: {
  priority: number;
}): CTABanner {
  const {data: activities} = fetchActivitiesRequest();

  const unfinishedActivity = activities?.in_progress?.find(
    (activity) => activity.started,
  );
  const {navigateToLearningPath} =
    useLearningPathNavigation(unfinishedActivity);

  return {
    priority,
    title: 'Atenção!',
    theme: 'light',
    color: '#fa2d2d',
    icon: 'exclamation-triangle',
    description:
      'você tem uma atividade em andamento. Vamos concluir antes que o prazo encerre?',
    isVisible: () => !!unfinishedActivity,
    action: {
      text: 'Continuar',
      onClick: navigateToLearningPath.currentStep,
    },
  };
}

export default useActivitiesToFinishBanner;
